import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
   apiKey: "AIzaSyB0mvkMizKK_e72j39rX4KyxBDPt8PHv9A",
  authDomain: "berhamporelaser-sc.firebaseapp.com",
  projectId: "berhamporelaser-sc",
  storageBucket: "berhamporelaser-sc.firebasestorage.app",
  messagingSenderId: "236375319692",
  appId: "1:236375319692:web:f60c67a873d0587e9987a9",
  measurementId: "G-K9NSJYLNGN"
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;


